import React from 'react';
import { Box, Container, Paper, Typography, Button, Divider } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Gavel as GavelIcon, Security as SecurityIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import NebenanHilfeLogo from '../UI/NebenanHilfeLogo';

const LegalPage = ({ type: propType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = propType || (location.pathname.includes('datenschutz') || location.pathname.includes('privacy') ? 'privacy' : 'agb');

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: 5 }}>
      <Container maxWidth="md">
        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ fontWeight: 700, textTransform: 'none' }}
          >
            Zurück
          </Button>
          <NebenanHilfeLogo size="small" />
        </Box>

        <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: '1px solid rgba(0,0,0,0.08)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            {type === 'agb' ? <GavelIcon color="primary" fontSize="large" /> : <SecurityIcon color="primary" fontSize="large" />}
            <Typography variant="h4" fontWeight={800}>
              {type === 'agb' ? 'Allgemeine Geschäftsbedingungen (AGB)' : 'Datenschutzerklärung (DSGVO)'}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            NebenanHilfe.de • Stand: August 2026
          </Typography>
          <Divider sx={{ mb: 4 }} />

          {type === 'agb' ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Typography variant="h6" fontWeight={700}>1. Geltungsbereich & Vertragsgegenstand</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Nachbarschaftsplattform <strong>NebenanHilfe.de</strong>. Die Plattform ermöglicht ehrenamtliche Nachbarschaftshilfe, lokales Leihen und Verschenken sowie Nachbarschaftskontakte im Quartier auf Grundlage christlicher Nächstenliebe und gegenseitigen Vertrauens.
              </Typography>

              <Typography variant="h6" fontWeight={700}>2. 100% Kostenfreiheit & Öffentliche Testphase (Beta-Version)</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                • <strong>Öffentliche Testphase</strong>: Die Plattform befindet sich aktuell in der öffentlichen Ausprobier- und Testphase (Beta-Version) für Bürgerinnen und Bürger.<br />
                • <strong>100% Kostenlos</strong>: Die Nutzung der gesamten Plattform NebenanHilfe.de ist für alle Bürgerinnen und Bürger vollständig kostenfrei.<br />
                • <strong>Keine Abos & Keine Gebühren</strong>: Es gibt keine Registrierungsgebühren, keine Mitgliedsbeiträge und keine Verträge.<br />
                • <strong>Nachbarschaftshilfe</strong>: Nachbarn unterstützen sich gegenseitig ehrenamtlich und unentgeltlich.
              </Typography>

              <Typography variant="h6" fontWeight={700}>3. Verhaltenskodex & Verpflichtung</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                Mitglieder verpflichten sich zu wahrheitsgemäßen Angaben, respektvoller Kommunikation und gegenseitiger Unterstützung. Beleidigungen, Diskriminierung oder kommerzieller Missbrauch sind untersagt.
              </Typography>

              <Typography variant="h6" fontWeight={700}>4. Haftungsausschluss</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                NebenanHilfe.de stellt die technische Plattform für das Miteinander im Quartier bereit. Für Absprachen, Hilfsdienste oder Leihgeschäfte, die direkt zwischen Nachbarn geschlossen werden, übernimmt die Plattform keine Haftung.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Typography variant="h6" fontWeight={700}>1. Verantwortlicher für den Datenschutz</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                Verantwortlich im Sinne der DSGVO ist das Betreiberteam von <strong>NebenanHilfe.de</strong> (E-Mail: support@nebenanhilfe.de).
              </Typography>

              <Typography variant="h6" fontWeight={700}>2. Datenerhebung & Zweck</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                Wir verarbeiten personenbezogene Daten (Name, E-Mail/Telefon, Postleitzahl) ausschließlich für die Bereitstellung der lokalen Hilfsangebote, Verifizierung im Quartier und sichere Kommunikation.
              </Typography>

              <Typography variant="h6" fontWeight={700}>3. Ihre Rechte laut DSGVO</Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Sperrung oder Löschung Ihrer Daten sowie Datenübertragbarkeit.
              </Typography>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default LegalPage;
